import React from 'react'
import { Button, Result } from 'antd'
import './ErrorBoundary.less'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false, error: null }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error }
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo)
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null })
        window.location.href = '/'
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary">
                    <Result
                        status="error"
                        title="Qualcosa è andato storto"
                        subTitle="Si è verificato un errore imprevisto. Ti preghiamo di ricaricare la pagina."
                        extra={[
                            <Button type="primary" key="reload" onClick={this.handleReset}>
                                Ricarica la pagina
                            </Button>,
                        ]}
                    />
                </div>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary